// This file contains email templates used throughout the application

export const getRegistrationEmailTemplate = (name: string, requiresApproval: boolean = false) => {
  const approvalText = requiresApproval 
    ? `<p style="margin-bottom: 20px;">Ihr Konto muss von einem Administrator freigeschaltet werden, bevor Sie sich anmelden können. Sie werden per E-Mail benachrichtigt, sobald Ihr Konto freigeschaltet wurde.</p>`
    : '';

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Willkommen bei Hoss Immo</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; }
        .logo { max-width: 200px; height: auto; }
        .content { background-color: #f9f9f9; padding: 20px; border-radius: 5px; }
        .footer { margin-top: 30px; font-size: 12px; color: #999999; text-align: center; }
        .button { display: inline-block; background-color: #41c7f0; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; font-weight: bold; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <img src="https://app.hoss-immo.de/lovable-uploads/df5d4a15-b764-48c8-93e7-2adbf679ef2c.png" alt="Hoss Immo Logo" class="logo">
        </div>
        
        <div class="content">
          <h2>Willkommen, ${name}!</h2>
          
          <p>Vielen Dank für Ihre Registrierung bei Hoss Immo. Wir freuen uns, Sie als neuen Nutzer begrüßen zu dürfen.</p>
          
          ${approvalText}
          
          <p>Sobald Sie sich anmelden können, erhalten Sie Zugang zu allen Funktionen unserer Plattform:</p>
          
          <ul>
            <li>Vollständiges Reporting für Ihre Kampagnen</li>
            <li>Lead-Verwaltung und CRM-Funktionen</li>
            <li>Personalisierbare Dashboards</li>
            <li>Und vieles mehr!</li>
          </ul>
          
          <p>Bei Fragen oder Problemen steht Ihnen unser Support-Team jederzeit zur Verfügung.</p>
          
          <p>Mit freundlichen Grüßen,<br>
          Ihr Hoss Immo Team</p>
        </div>
        
        <div class="footer">
          <p>Diese E-Mail wurde automatisch generiert. Bitte antworten Sie nicht auf diese Nachricht.</p>
          <p>© 2024 Hoss Immo. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const getPasswordResetEmailTemplate = (name: string, resetLink: string) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Zurücksetzen Ihres Passworts</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; }
        .logo { max-width: 200px; height: auto; }
        .content { background-color: #f9f9f9; padding: 20px; border-radius: 5px; }
        .footer { margin-top: 30px; font-size: 12px; color: #999999; text-align: center; }
        .button { display: inline-block; background-color: #41c7f0; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; font-weight: bold; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <img src="https://app.hoss-immo.de/lovable-uploads/df5d4a15-b764-48c8-93e7-2adbf679ef2c.png" alt="Hoss Immo Logo" class="logo">
        </div>
        
        <div class="content">
          <h2>Passwort zurücksetzen</h2>
          
          <p>Hallo ${name},</p>
          
          <p>Sie haben eine Anfrage zum Zurücksetzen Ihres Passworts gestellt. Klicken Sie auf den folgenden Button, um ein neues Passwort zu erstellen:</p>
          
          <p style="text-align: center;">
            <a href="${resetLink}" class="button">Passwort zurücksetzen</a>
          </p>
          
          <p>Falls Sie diese Anfrage nicht gestellt haben, können Sie diese E-Mail ignorieren. Ihr Passwort wird nicht geändert.</p>
          
          <p>Der Link ist 24 Stunden gültig.</p>
          
          <p>Mit freundlichen Grüßen,<br>
          Ihr Hoss Immo Team</p>
        </div>
        
        <div class="footer">
          <p>Diese E-Mail wurde automatisch generiert. Bitte antworten Sie nicht auf diese Nachricht.</p>
          <p>© 2024 Hoss Immo. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const getContactConfirmationEmailTemplate = (name: string, message: string) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Ihre Kontaktanfrage ist eingegangen</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; }
        .logo { max-width: 200px; height: auto; }
        .content { background-color: #f9f9f9; padding: 20px; border-radius: 5px; }
        .message-box { background-color: #eaeaea; padding: 15px; border-radius: 5px; margin: 20px 0; }
        .footer { margin-top: 30px; font-size: 12px; color: #999999; text-align: center; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <img src="https://app.hoss-immo.de/lovable-uploads/df5d4a15-b764-48c8-93e7-2adbf679ef2c.png" alt="Hoss Immo Logo" class="logo">
        </div>
        
        <div class="content">
          <h2>Ihre Kontaktanfrage ist eingegangen</h2>
          
          <p>Hallo ${name},</p>
          
          <p>vielen Dank für Ihre Anfrage. Wir haben folgende Nachricht von Ihnen erhalten:</p>
          
          <div class="message-box">
            ${message}
          </div>
          
          <p>Ein Mitglied unseres Teams wird sich in Kürze mit Ihnen in Verbindung setzen.</p>
          
          <p>Mit freundlichen Grüßen,<br>
          Ihr Hoss Immo Team</p>
        </div>
        
        <div class="footer">
          <p>Diese E-Mail wurde automatisch generiert. Bitte antworten Sie nicht auf diese Nachricht.</p>
          <p>© 2024 Hoss Immo. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const getNewsletterTemplate = (name: string, content: string) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Hoss Immo Newsletter</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { text-align: center; margin-bottom: 30px; }
        .logo { max-width: 200px; height: auto; }
        .content { background-color: #f9f9f9; padding: 20px; border-radius: 5px; }
        .newsletter-content { margin: 20px 0; }
        .footer { margin-top: 30px; font-size: 12px; color: #999999; text-align: center; }
        .button { display: inline-block; background-color: #3D6D77; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; font-weight: bold; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <img src="https://app.hoss-immo.de/lovable-uploads/df5d4a15-b764-48c8-93e7-2adbf679ef2c.png" alt="Hoss Immo Logo" class="logo">
        </div>
        
        <div class="content">
          <h2>Hoss Immo Newsletter</h2>
          
          <p>Hallo ${name},</p>
          
          <p>hier ist unser neuester Newsletter mit aktuellen Informationen und Angeboten:</p>
          
          <div class="newsletter-content">
            ${content}
          </div>
          
          <p style="text-align: center; margin-top: 30px;">
            <a href="https://hoss-immo.de/angebote" class="button">Aktuelle Angebote ansehen</a>
          </p>
          
          <p>Mit freundlichen Grüßen,<br>
          Ihr Hoss Immo Team</p>
        </div>
        
        <div class="footer">
          <p>Sie erhalten diese E-Mail, weil Sie sich für unseren Newsletter angemeldet haben.</p>
          <p>Um sich abzumelden, klicken Sie bitte <a href="https://hoss-immo.de/abmelden">hier</a>.</p>
          <p>© 2024 Hoss Immo. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </body>
    </html>
  `;
};
